import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForeignCurrencyAccounts from "../../components/ForeignCurrencyAccounts";
import request from "../../utils/request";
const Swal = require("sweetalert2");

const SarlaftPNatural = ({
  onCancel,
  naturalPersonForm,
  naturalPersonReset,
  naturalPersonState,
  successfulCreateNaturalPerson,
  errorsCreateNaturalPerson,
  naturalPerson,
}) => {
  const history = useHistory();
  const [dataPartners, setDataPartners] = useState([]);
  const [dataForeignCurrencyAccounts, setDataForeignCurrencyAccounts] =
    useState([]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const monedaExtranjera = useRef({});
  monedaExtranjera.current = watch("moneda_extranjera", "");

  const cuentasMonedaExtranjera = useRef({});
  cuentasMonedaExtranjera.current = watch("cuentas_moneda_extranjera", "");

  const [showInputPromoter, setShowInputPromoter] = useState(false);

  const handleSelectChange = (event) => {
    setShowInputPromoter(event.target.value === "Contacto con Promotor");
  };

  // useEffect(() => {
  //   setValue("tipo_operacion", "");
  // }, [monedaExtranjera.current]);

  useEffect(() => {
    if (successfulCreateNaturalPerson) {
      Swal.fire({
        title: "Proceso exitoso!",
        text: "El formulario fue enviado exitosamente.",
        icon: "success",
        confirmButtonText: 'Ok'
      })

      try {
        let contenido = {
          "to": `${naturalPerson.email}`,
          "expiresIn": "1500000",
          "html": `<table
          style="width: 100% !important; table-layout: fixed"
          align="center"
          bgcolor="#ececec"
        >
          <tbody>
            <tr>
              <td>
                <table
                  style="max-width: 800px; margin: auto; width: 100%"
                  align="center"
                >
                  <tbody>
                    <tr>
                      <td
                        style="
                          font-size: 16px;
                          font-weight: bold;
                          padding-top: 20px;
                          padding-bottom: 20px;
                          padding-left: 25px;
                          padding-right: 25px;
                          text-align: center;
                          color: #353e4a;
                          font-family: Arial, sans-serif;
                        "
                        align="center"
                        width="100%"
                      >
                        Solicitud de acceso recibida
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 8px">
                        <table
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 15px;
                            margin: auto;
                            width: 100%;
                          "
                          align="center"
                          bgcolor="#ffffff"
                          border="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: #1e80b6;
                                  padding-top: 20px;
                                  padding-bottom: 10px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                "
                              >
                                Hola ${naturalPerson.nombres} ${naturalPerson.apellidos}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  line-height: 24px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                  padding-bottom: 10px;
                                "
                              >
                                Soy Naideth Perú, <br />
                                Hemos recibido tu solicitud de acceso a la plataforma, 
                              </td>
                            </tr>
                            <tr>
                              <td style="height: 5px" height="5"></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <table
                          width="100%"
                          border="0"
                          align="center"
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            margin: auto;
                            background-color: #ffffff;
                          "
                          cellpadding="0"
                          cellspacing="0"
                        >
                          <tbody>
                    <tr>
                      <td style="background-color: #ececec">
                        <table
                          width="100%"
                          border="0"
                          align="center"
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 14px;
                            margin: auto;
                            padding-bottom: 10px;
                          "
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: 75;
                                  font-size: 12px;
                                  padding-top: 10px;
                                  padding-bottom: 10px;
                                "
                              >
                                Este email se ha generado automáticamente. Por
                                favor, no conteste a este email.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>`,
          "channel": "Naideth_Peru",
          "subject": "Solicitud recibida",
          "category": ""
        }
        fetch("https://notificaciones.cic.travel/api/mails", {
          method: "POST", body: JSON.stringify(contenido), headers: new Headers({
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          }),
        });
        let contenidoAviso = {
          "to": "creacion.clientes@ciccolombia.travel",
          "expiresIn": "1500000",
          "html": `<table
          style="width: 100% !important; table-layout: fixed"
          align="center"
          bgcolor="#ececec"
        >
          <tbody>
            <tr>
              <td>
                <table
                  style="max-width: 800px; margin: auto; width: 100%"
                  align="center"
                >
                  <tbody>
                    <tr>
                      <td
                        style="
                          font-size: 16px;
                          font-weight: bold;
                          padding-top: 20px;
                          padding-bottom: 20px;
                          padding-left: 25px;
                          padding-right: 25px;
                          text-align: center;
                          color: #353e4a;
                          font-family: Arial, sans-serif;
                        "
                        align="center"
                        width="100%"
                      >
                      Nueva solicitud de creacion - Perú
                      </td>
                    </tr>
                    <tr>
                      <td style="padding-bottom: 8px">
                        <table
                          style="
                            color: #353e4a;
                            font-family: Arial, sans-serif;
                            font-size: 15px;
                            margin: auto;
                            width: 100%;
                          "
                          align="center"
                          bgcolor="#ffffff"
                          border="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="
                                  color: #1e80b6;
                                  padding-top: 20px;
                                  padding-bottom: 10px;
                                  padding-left: 20px;
                                  padding-right: 20px;
                                "
                              >
                                Nueva solicitud de creacion, actualizacion de clientes o proveedor recibida
                              </td>
                              </tr>
                            <tr>
                              <td
                              align="center"
                              style="
                                background-color: #ef5401;
                                padding: 7px;
                                font-family: Arial, sans-serif;
                              "
                              >
                              <a
                                style="
                                  background-color: #ef5401;
                                  font-family: Arial, sans-serif;
                                  border: medium none;
                                  border-radius: 3px;
                                  color: white;
                                  font-size: 21px;
                                  height: 30px;
                                  text-decoration: none;
                                  padding-top: 7px;
                                  padding-bottom: 7px;
                                  padding-left: 30px;
                                  padding-right: 30px;
                                "
                                href="https://sarlaft.cic.travel/"
                                target="_blank"
                                >Ir a la plataforma</a
                              ><a> </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>`,
          "channel": "Naideth_Peru",
          "subject": "Nueva solicitud de creación o actualización de cliente",
          "category": ""
        }
        fetch("https://notificaciones.cic.travel/api/mails", {
          method: "POST", body: JSON.stringify(contenidoAviso), headers: new Headers({
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          }),
        });
      } catch (err) {
        console.log('...')
      }
    }
  }, [successfulCreateNaturalPerson]);

  const onSubmit = (data) => {
    const file_rut = data.file_rut && data.file_rut[0];

    naturalPersonForm({
      ...data,
      estado: "CREADA",
      file_rut: file_rut
    });

    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ fontSize: "14px" }} autoComplete="off">
      <i className="fas fa-arrow-left" onClick={onCancel} style={{ cursor: "pointer" }}></i>
      <h2 className="text-center text-gray-800 mb-5">Crear nueva persona natural</h2>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Ciudad</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="ciudad"
            {...register("ciudad", { required: true })}
          />
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Pais</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="pais"
            {...register("pais", { required: true })}
          />
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Tipo de solicitud</label>
          <select
            id
            className="form-control  form-control-user form-select"
            name="tipo_solicitud"
            {...register("tipo_solicitud", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Nuevo">Nuevo</option>
          </select>
        </div>
        <div className="form-group col-md-2">
          <label className="form-label">Clase vinculación</label>
          <select
            id
            className="form-control  form-control-user form-select"
            name="clase_vinculacion"
            {...register("clase_vinculacion", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="Cliente">Cliente</option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">¿Cómo nos encontraste?</label>
          <select
              id
              className="form-control  form-control-user form-select"
              name="fuente_referencia"
              {...register("fuente_referencia", {
                required: true,
              })}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione una opción</option>
              <option value="Redes Sociales">Redes Sociales (Facebook, Instagram, Twitter, etc.)</option>
              <option value="Recomendación de un amigo">Recomendación de un amigo</option>
              <option value="Publicidad en línea">Publicidad en línea</option>
              <option value="Correo electrónico">Correo electrónico</option>
              <option value="Blog o artículo">Blog o artículo</option>
              <option value="Contacto con Promotor">Contacto con Promotor</option>
              <option value="Otro">Otro</option>
            </select>
        </div>
      </div>
      {showInputPromoter && (
        <>
          <div className="row mt-3 justify-content-end">
            <div className="form-group col-md-3">
              <label className="form-label">Nombre del promotor</label>
              <input
                type="text"
                onInput={(e) =>
                  (e.target.value = ("" + e.target.value).toUpperCase())
                }
                style={{ textTransform: "uppercase" }}
                className="form-control form-control-user"
                name="promotor"
                {...register("promotor", {
                  required: true,
                })}
              />
            </div>
          </div>
        </>
      )}
      <div className="card-header  mt-3">1. PERSONA NATURAL</div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Apellidos</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="apellidos"
            {...register("apellidos", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Nombres</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nombres"
            {...register("nombres", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Tipo de documento</label>
          <select
            id
            className="form-control  form-control-user form-select"
            name="tipo_doc"
            {...register("tipo_doc", { required: true })}
          >
            <option value="">Seleccione una opción</option>
            <option value="DNI">DNI</option>
            <option value="CE">CE</option>
            <option value="OTRO">OTRO</option>
          </select>
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">No. documento</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nombres"
            {...register("numero_documento", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="form-group col-md-3">
          <label className="form-label">Fecha nacimiento</label>
          <input
            id
            type="date"
            className="form-control  form-control-user"
            name="fec_nac"
            {...register("fec_nac", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Lugar de Nacimiento</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="lugar_nacimiento"
            {...register("lugar_nacimiento", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Nacionalidad</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="nacionalidad"
            {...register("nacionalidad", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Ocupación /Oficio</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="ocupacion"
            {...register("ocupacion", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Profesión</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="profesion"
            {...register("profesion", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Teléfono</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="telefono"
            {...register("telefono", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Celular</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="celular"
            {...register("celular", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Dirección residencia</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="direccion_res"
            {...register("direccion_res", {
              required: true,
            })}
          />
        </div>
        <div className="form-group col-md-3">
          <label className="form-label">Distrito</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="mcpio"
            {...register("mcpio", {
              required: true,
            })}
          />
        </div>

        <div className="form-group col-md-3">
          <label className="form-label">Correo electrónico</label>
          <input
            type="text"
            onInput={(e) =>
              (e.target.value = ("" + e.target.value).toUpperCase())
            }
            style={{ textTransform: "uppercase" }}
            className="form-control form-control-user"
            name="email"
            {...register("email", {
              required: true,
            })}
          />
        </div>
      </div>
      <div className="card-header mt-3">2. DOCUMENTOS REQUERIDOS</div>
      <div className="row mt-3">
        <div className="form-group col-md-12">
          <label className="form-label">
            1. Documento de identidad (DNI)
          </label>
          <input
            id
            type="file"
            className="form-control form-control-user"
            name="file_rut"
            {...register("file_rut", {
              required: false,
            })}
          />
        </div>
        <input
          id
          type="hidden"
          className="form-control form-control-user"
          name="sys"
          value="PER"
          {...register("sys")}
        />
      </div>
      <div className="modal-footer justify-content-center">
        <button type="submit" className="btn btn-danger p-3 col-sm-3 col-10 mt-2" style={{ borderRadius: "50px" }}>
          Enviar
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  return {
    naturalPersonState: state.naturalPersonState,
    successfulCreateNaturalPerson:
      state.naturalPersonState.successfulCreateNaturalPerson,
    errorsCreateNaturalPerson:
      state.naturalPersonState.errorsCreateNaturalPerson,
    naturalPerson: state.naturalPersonState.naturalPerson,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    naturalPersonForm: (payload) =>
      dispatch({
        type: "CREATE_NATURAL_PERSON_REQUEST",
        value: payload,
      }),
    naturalPersonReset: () =>
      dispatch({
        type: "CREATE_NATURAL_PERSON_RESET",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SarlaftPNatural);
